import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
} from '@mui/material';
import { DEFAULT_POSITION } from '../config/config'


export default function Reset({ title, data = [],
  selectSubCity, setSelectSubCity,
  selectArea, setSelectArea,
  selectMsh, setSelectMsh,
  selectBsn, setSelectBsn,
  selectTelCode, setSelectTelCode,
  selectShelterCode, setSelectShelterCode,
  setRiskMapZoom, setRiskMapCenter,
  setBsnMapZoom, setBsnMapCenter,
  isReady, setReady
}) {
  const [groupedData, setGroupedData] = useState([]);
  const [disable, setDisable] = useState(true);
  const [color, setColor] = useState('gray');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (selectSubCity.length > 0
      || selectArea.length > 0
      || selectMsh.length > 0
      || selectBsn.length > 0
      || selectTelCode.length > 0
      || selectShelterCode.length > 0
    ) {
      setDisable(false);
      setColor('white');
    }
    else {
      setDisable(true);
      setColor('gray');
    }
  }, [selectSubCity, selectArea, selectMsh, selectBsn, selectTelCode, selectShelterCode]);

  // ローディング終了
  useEffect(() => {
    if (Object.values(isReady).every(v => v === true)
    ) {
      setLoading(false)
    }
  }, [isReady]);

  // フィルター処理（groupedDataのあとに追加）
  const filteredData = groupedData
  const handleReset = () => {
    if (disable) {
      return
    }
    // リセットボタンのローディング開始
    setLoading(true)

    // 各チャートのローディング開始
    setReady(prev => {
      const updated = Object.fromEntries(
        Object.keys(prev).map(key => [key, false])
      );
      return updated;
    });

    // ローディング開始後にリセット処理を開始
    requestAnimationFrame(() => {
      setTimeout(() => {
        setRiskMapCenter(DEFAULT_POSITION)
        setRiskMapZoom(9)
        setBsnMapCenter(DEFAULT_POSITION)
        setBsnMapZoom(9)
        if (selectSubCity.length > 0) setSelectSubCity([]);
        if (selectArea.length > 0) setSelectArea([]);
        if (selectMsh.length > 0) setSelectMsh([]);
        if (selectBsn.length > 0) setSelectBsn([]);
        if (selectTelCode.length > 0) setSelectTelCode([]);
        if (selectShelterCode.length > 0) setSelectShelterCode([]);
      }, 0);
    });
  };

  return (
    <>
      <Box sx={{ mb: 1 }}>
        {loading ?
          <Button
            fullWidth
            variant="outlined"
            sx={{
              display: 'flex', height: '23px',
              fontSize: { xs: '0.75rem', sm: '0.75rem', md: 'clamp(0.5rem, 0.313rem + 0.5vw, 0.75rem)' },
              color: 'white', borderColor: 'white', fontWeight: 'bold'
            }}
          >
            <CircularProgress
              size={10}
              color="inherit"
              disableShrink
              component="span"
              sx={{
                color: 'white',
                '& circle': {
                  stroke: 'white', 
                },
              }}
            />
          </Button>
          :
          <Button
            fullWidth
            variant="outlined"
            onClick={handleReset}
            disable={disable}
            sx={{
              display: 'flex', height: '23px',
              fontSize: { xs: '0.75rem', sm: '0.75rem', md: 'clamp(0.5rem, 0.313rem + 0.5vw, 0.75rem)' },
              color: color, borderColor: color, fontWeight: 'bold'
            }}
          >
            リセット
          </Button>
        }
      </Box>
    </>
  );
};
